<template>
  <button
    class="bottom-banner m-btn"
    @click.stop="openModal(MODAL_TYPES.summerGift)"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '~/components/v2/common/AppHeader/data';

export default {
  name: 'BottomBannerOnlyImage',
  data: () => ({
    MODAL_TYPES,
  }),
  methods: {
    ...mapActions('appHeaderModals', ['openModal']),
  },
};
</script>

<style lang="scss" scoped>
.bottom-banner {
  display: block;
  position: relative;
  width: 100%;
  height: calc(var(--scale) * 60);
  background-image: url("/v2/global/banner-only-image/banner-bg.webp");
  background-position: center;
  background-size: cover;
  overflow: hidden;
  outline: none;

  @include media-down($size-tablet) {
    background-image: url("/v2/global/banner-only-image/banner-bg-tablet.webp");
    height: calc(var(--scale) * 50);
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/global/banner-only-image/banner-bg-mob.webp");
  }
}
</style>
